export const environment = {
  baseUrl: '/api/fe',
  appUrl: 'https://app-t.finserviceesg.com',
};
